// extracted by mini-css-extract-plugin
module.exports = {"links":"links__3361E","linksLabel":"linksLabel__2TBU2","wrapper":"wrapper__1ioBu","link":"link__1Q6PO","title":"title__2jRG4","icon":"icon__2Uw3g"};